import React, { Component } from 'react';
import {NavLink, withRouter} from 'react-router-dom';
/* Font Awesome Icons */ 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLinkId: this.decideActiveLinkId()
    };
  }

  decideActiveLinkId = () => {
    let validLinkId = ['regional-performance', 'delay-overview', 'customer-understanding'],
    currentId = this.props.history.location.pathname.split('/')[1];
    if (validLinkId.indexOf(currentId) !== -1 ) {
      return currentId;
    } else {
      return 'delay-overview';
    }
  }
  render() {
    let {showNavBar} = this.props,
        {activeLinkId} = this.state;
      return (
          (
              <div className= { "col-10 col-sm-3 col-lg-2 nav-bar " + (showNavBar ? 'nav-bar-show' : 'nav-bar-media')}>
                <div className="nav-bar-wrapper">
                  <ul>
                    <li>
                      <div className="link-container">
                        <NavLink to={`${process.env.PUBLIC_URL}/delay-overview`} id="delay-overview" className={(activeLinkId === 'delay-overview') ? 'activeLink': ''} onClick={()=> {this.handleLinkClick('delay-overview')}}><FontAwesomeIcon className="icons" icon="hourglass"/>Delay Overview</NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="link-container">
                        <NavLink to={`${process.env.PUBLIC_URL}/regional-performance`} id="regional-performance" className={(activeLinkId === 'regional-performance') ? 'activeLink': ''} onClick={()=> {this.handleLinkClick('regional-performance')}}><FontAwesomeIcon className="icons" icon="globe-americas"/>Regional Performance</NavLink>
                      </div>
                    </li>
                    <li>
                      <div className="link-container">
                        <NavLink to={`${process.env.PUBLIC_URL}/customer-understanding`} id="customer-understanding" className={(activeLinkId === 'customer-understanding') ? 'activeLink': ''} onClick={()=> {this.handleLinkClick('customer-understanding')}} ><FontAwesomeIcon className="icons" icon="user"/>Customer Understanding</NavLink>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
          )
      );
    }
    
/**
 * Function to change the active link and to hide the navbar on smaller devices
 */
    handleLinkClick = (linkId) => {
      this.setState({activeLinkId: linkId});
      if(window.innerWidth < 576) {
        this.props.handleNavBar(!this.props.showNavBar);
      }
    }
}

export default withRouter(NavBar);


// WEBPACK FOOTER //
// ./src/components/NavBar.js